import moment from 'moment';
import * as React from 'react';

export const isObject = (obj: any) => {
	return !!obj && obj.constructor === Object;
};

export const listenForOutsideClicks = (
	elementRef: React.MutableRefObject<null>,
	isOpen: boolean,
	setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
) => {
	const checkClickOutside = (e: any) => {
		if (elementRef.current !== null && (elementRef.current as any).contains(e.target)) return;
		setIsOpen(false);
	};

	return React.useEffect(() => {
		if (!elementRef.current) return;

		if (isOpen) {
			['click', 'touchstart'].forEach((type) => {
				document.addEventListener(type, checkClickOutside);
			});
		} else {
			['click', 'touchstart'].forEach((type) => {
				document.removeEventListener(type, checkClickOutside);
			});
		}

		// cleanup on unmount
		return () => {
			['click', 'touchstart'].forEach((type) => {
				document.removeEventListener(type, checkClickOutside);
			});
		};
	}, [isOpen]);
};

export const queryStringToObject = (str?: string) => {
	const queryString = str || location.search;
	let queryObject: { [key: string]: string } = {};

	queryString
		.slice(1)
		.split('&')
		.map((p) => {
			const pair = p.split('=');
			const [key, value] = pair.map(decodeURIComponent);
			queryObject[key] = value;
		});

	return queryObject;
};

export const validationErrorsToString = (validationErrors: { [key: string]: string }[]) => {
	const errors = validationErrors.map((entry) => {
		return `${entry.reason} \n`;
	});

	return errors.sort().join('');
};

export const checkAndLogErrors = (response: any) => {
	if (response.validationErrors.length) {
		console.log(validationErrorsToString(response.validationErrors));
	} else {
		console.log(response.message);
	}
};

export const formatToCurrency = (val: number) => {
	let currentVal = val.toFixed(2);

	// put in thousand separators for the integer part
	if (currentVal.length > 1) {
		currentVal = currentVal.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
	}

	return currentVal;
};

export const parseDate = (str: string) => {
	const parsedDate = moment(str, 'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ');
	const newDate = parsedDate.isValid() ? parsedDate.toDate() : new Date();

	return newDate;
};

///Google Recaptcha V3 Invisible
export const SITE_KEY = '6LfoBlwhAAAAAMhlhqK5IVeMKZsas3czgvdqbpLT';

export const loadScriptByURL = (id: any, callback: any) => {
	const url = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
	const isScriptExist = document.getElementById(id);

	if (!isScriptExist) {
		var script = document.createElement('script');
		script.type = 'text/javascript';
		script.src = url;
		script.id = id;
		script.async;
		script.defer;
		script.onload = function () {
			if (callback) callback();
		};
		document.body.appendChild(script);
	}

	if (isScriptExist && callback) callback();
};

export type ListType = [] | { value: string; label: string }[];

export const statesList = [
	{ label: 'Australian Capital Territory', value: 'act' },
	{ label: 'New South Wales', value: 'nsw' },
	{ label: 'Northern Territory', value: 'nt' },
	{ label: 'Queensland', value: 'qld' },
	{ label: 'South Australia', value: 'sa' },
	{ label: 'Tasmania', value: 'tas' },
	{ label: 'Victoria', value: 'vic' },
	{ label: 'Western Australia', value: 'wa' }
];

export const complaintsCategoryList = [
	{ label: 'Unsafe teacher behaviour', value: 'unsafe teacher behaviour' },
	{ label: 'Discrimination', value: 'discrimination' },
	{ label: 'Category 3', value: 'category 3' }
];

export const complaintsResolveTypes = [
	{ label: 'Insufficient information', action: 'No further action required', value: 'insufficient information' },
	{
		label: 'Complaint withdrawn by complainant',
		action: 'No further action required',
		value: 'complaint withdrawn by complainant'
	},
	{
		label: 'Complaint investigated and not substantiated',
		action: 'Please ensure all actions & reasons recorded and notes retained',
		value: 'complaint investigated and not substantiated'
	},
	{
		label: 'Complaint investigated and substantiated',
		action:
			'Please record disciplinary actions taken, authorities notified, communication with parents & child and support provided, actionstaken by the organisation to reduce the risk of this occurring again.',
		value: 'complaint investigated and substantiated'
	}
];

export const incidentCategoryList = [
	{ label: 'Others', value: 'Others' }
	// { label: 'Negligence', value: 'negligence' },
	// { label: 'Accident', value: 'accident' },
	// { label: 'Category 3', value: 'category 3' }
];

export const feedbackCategoryList = [
	{ label: 'Negligence', value: 'negligence' },
	{ label: 'Accident', value: 'accident' },
	{ label: 'Category 3', value: 'category 3' }
];

export const feedbackResolveTypes = [
	{ label: 'Insufficient information', action: 'No further action required', value: 'insufficient information' },
	{ label: 'Further enquiries made', action: 'No further action required', value: 'further enquiries made' },
	{ label: 'Actions taken', action: 'Please describe below', value: 'actions taken' },
	{ label: 'Escalated to an incident report', action: '', value: 'escalated to an incident report' },
	{ label: 'Escalated to a complaint', action: '', value: 'escalated to a complaint' },
	{ label: 'Other...', action: 'Please describe below', value: 'other' }
];

export const permissionsList = [
	{ label: 'Must view and acknowledge', value: 'must view and acknowledge' },
	{ label: 'Can view', value: 'can view' },
	{ label: 'Can not view', value: 'can not view' }
];

export const trainingTypes = [
	{ label: 'CPR training', value: 'cpr training' },
	{ label: 'Others', value: 'others' }
];

export const staffList = [
	{ label: 'Tim Larkin', value: 'tim larkin', id: '12345' },
	{ label: 'Peter Parker', value: 'peter parker', id: '12345' },
	{ label: 'John Smith', value: 'john smith', id: '12345' }
];

export const childSafetyStandardsList = [
	{ label: 'Leadership, governance and culture', value: 'leadership' },
	{ label: 'Children’s participation and empowerment', value: 'children participation' },
	{ label: 'Family and community involvement', value: 'family' },
	{ label: 'Equity and diverse needs', value: 'equity' },
	{ label: 'Human resources management', value: 'hr' },
	{ label: 'Child-focused complaints process', value: 'complaints' },
	{ label: 'Staff education and training', value: 'training' },
	{ label: 'Physical and online environment', value: 'environment' },
	{ label: 'Review and continuous improvement', value: 'improvement' },
	{ label: 'Child safe policy and procedures', value: 'policy' }
];

export const emailRegex =
	/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const usePrevious = (value: any) => {
	const ref = React.useRef(value);

	React.useEffect(() => {
		ref.current = value; //assign the value of ref to the argument
	}, [value]); //this code will run when the value of 'value' changes

	return ref.current; //in the end, return the current ref value.
};

export const rteSettings = {
	modules: {
		toolbar: [
			[{ header: [1, 2, 3, 4, 5, 6] }, { font: [] }],
			[{ size: [] }],
			[{ color: [] }, { background: [] }],
			['bold', 'italic', 'underline', 'blockquote', 'strike'],
			[{ script: 'sub' }, { script: 'super' }],
			[{ indent: '-1' }, { indent: '+1' }],
			[{ direction: 'rtl' }],
			[{ align: [] }],
			[{ list: 'ordered' }, { list: 'bullet' }],
			['link', 'image', 'video']
		]
	},

	formats: [
		'header',
		'font',
		'size',
		'bold',
		'italic',
		'underline',
		'strike',
		'blockquote',
		'list',
		'bullet',
		'indent',
		'color',
		'background',
		'link',
		'image',
		'video',
		'direction',
		'align',
		'script'
	]
};

export const staffRoleList = [
	{ label: 'Teacher', value: 'Teacher' },
	{ label: 'Parent', value: 'Parent' },
	{ label: 'Student', value: 'Student' },
	{ label: 'Visitor', value: 'Visitor' }
];

export const staffTypeList = [
	{ label: 'Principal', value: 'Principal' },
	{ label: 'Vice or Assistant Principal', value: 'VicePrincipal' },
	{ label: 'Teacher', value: 'Teacher' },
	{ label: 'Teacher aides', value: 'TeacherAides' },
	{ label: 'Librarian', value: 'Librarian' }
];

export const photoIDTypes = [
	{ label: 'Drivers Licence', value: 'DriversLicenceCertification' },
	{ label: 'Passport', value: 'PassportCertification' }
];
export const qualificationTypes = [
	{ label: 'Bachelors Degree', value: 'BachelorsDegree' },
	{ label: 'Associate Degree', value: 'AssociateDegree' },
	{ label: 'Advanced Diploma', value: 'AdvancedDiploma' },
	{ label: 'Diploma', value: 'Diploma' }
];
export const parentRelationshipTypes = [
	{ label: 'Parent', value: 'Parent' },
	{ label: 'Guardian', value: 'Guardian' }
];

export const childSafeStandardsColorCodes = [
	'#D25DAF',
	'#E02F15',
	'#F99935',
	'#FFCD39',
	'#CDD747',
	'#30BC4D',
	'#5AD1AA',
	'#58AFDA',
	'#3878BB',
	'#7224A9'
];
